
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactTable from '../../AdminPanel/SubComp/Grid/Table/';

// utils
import { Translations } from '../../../../utils';

// restClient
import { blockUi, unBlockUi } from '../../../../actions/actionCreator';
import { eapiClient } from '../../../../restClient';

//style
import './ProductRequests.css';

class ProductRequests extends Component {
  constructor(props) {
    super(props)
    this.state = {
      productData: undefined
    };
  }

  componentWillMount() {
    this.props.blockUi();
    if (this.props.caseId !== undefined) {
      this.loadCurrentState();
    }

  }

  loadCurrentState = () => {
    this.props.blockUi();
    eapiClient('/cases/' + this.props.caseId + '/clientsphere-products')
      .then(({ data }) => {
        var productsList = [];
        Object.keys(data.responseData).map((product, index) => {
          if (product === "gls") {
            data.responseData[product].forEach(item => {
              item['productName'] = `${item.csProductType ? item.csProductType['name'] : item.glsProductType['name']}`
              item['country'] = `${item.country['name'] === 'Other' ? item.otherCountryValue : item.country['name']}`
              productsList.push(item);
            })
          } else if (product === "eChannels") {
            data.responseData[product].forEach(item => {
              if (item.newEchannel) {
                item['productName'] = `${item.csProductType ? item.csProductType['name'] : item.eChannelType['name'] || item.eChannelType['value']}`
                item['country'] = `${item.country['name'] === 'Other' ? item.otherCountryValue : item.country['name']}`
                productsList.push(item);
              }

            })
          } else if (product === "csOtherProduct") {
            data.responseData[product].forEach(item => {
              item['productName'] = `${item.otherProductValue}`
              item['country'] = `${item.country['name'] === 'Other' ? item.otherCountryValue : item.country['name']}`
              productsList.push(item);
            })
          } else {
            data.responseData[product].forEach(item => {
              item['productName'] = `${item.csProductType ? item.csProductType['name'] : item.productType}`
              item['country'] = `${item.country['name'] === 'Other' ? item.otherCountryValue : item.country['name']}`
              productsList.push(item);
            })
          } //destructuring
        })
        this.setState({
          productData: data.responseData,
          productsToDisplay: productsList
        })
      });
    this.props.unBlockUi();
  }

  _addProduct = () => {
    this.props.history.push('/admin-panel/add-product', {
      pageJson: this.props.pageJson,
      mode: 'add'
    })
  }

  rowLink = (product) => {
    let apiUrl;
    if (product.eChannelType !== undefined) {
      apiUrl = `/product/echannel/` + product.id;
    } else if (product.glsProductType !== undefined) {
      apiUrl = `/product/gls/` + product.id;
    } else if (product.productType !== undefined) {
      apiUrl = `/product/` + product.productType + '/' + product.id;
    }

    eapiClient(apiUrl, {
      method: "GET"
    })
      .then(({ data }) => {
        let productDetails = data.responseData;
        productDetails['status'] = data.responseData['csProductStatus']
        if (data.responseData['closeDate'] !== undefined) { productDetails['Dateclosed'] = moment(data.responseData['closeDate']).format("DD MMM YYYY") }
        if (data.responseData['activationDate'] !== undefined) { productDetails['Dateactivated'] = moment(data.responseData['activationDate']).format("DD MMM YYYY") }

        this.props.history.push('/admin-panel/add-product', {
          pageJson: this.props.pageJson,
          mode: 'edit',
          currentProduct: productDetails
        })

      })
  }

  deleteProduct = (product) => {
    let apiUrl;
    if (product.productType === "account") {
      apiUrl = `/product/accounts/` + product.id + '/clientSphere';
    } else if (product.eChannelType !== undefined) {
      apiUrl = `/product/echannels/` + product.id + '/clientSphere';
    } else if (product.glsProductType !== undefined) {
      apiUrl = `/product/glses/` + product.id + '/clientSphere';
    } else {
      apiUrl = `/product/` + product.productType + '/' + product.id + '/clientSphere';
    }

    eapiClient(apiUrl, {
      method: "DELETE"
    })
      .then(({ data, status }) => {
        console.log("Deleted Product", data.status)
        if (status === 200) {
          this.loadCurrentState();
        }
      });
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  columnsHeader = () => {
    let columns = []
    var options = [this.translations(this.props.pageJson.static_text_ProductinCase.text), "Location", ""];
    var ids = ["productName", "country", "deleteUser"]
    ids.map((item, index) => {
      columns.push({
        accessor: item,
        Header: options[index],
        sortable: item === 'group' ? true : false
      })

    })
    return columns;
  }


  render() {
    return (
      <div className="gdoc-product-grid" >
        <div className="create-product-section">
          <button
            className="create-product-btn-export"
            onClick={this._addProduct}
          // disabled={this.props.isTnC}
          >
            + {this.translations(this.props.pageJson.guidebutton_AddProduct.text)}
          </button>
        </div>
        <div className="gdocs-clear-both"></div>
        <div className='gdocs-productList-section'>
          <ReactTable
            data={this.state.productsToDisplay}
            columns={this.columnsHeader()}
            pageJsonContent={this.props.pageJson.static_text_ProductinCase}
            isCaseList={true}
            rowLink={(data) => this.rowLink(data)}
            noLink={(data) => this.deleteProduct(data)}
            className="-striped -highlight"
            lang={this.props.lang}
            sortable={false}
            isCheckbox={false}
            showPagination={true}
          />
        </div>
      </div>)
  }
}

const mapStateToProps = (state, props) => {
  return {
    lang: state.lang,
    caseId: state.newManualCase.caseId
  }
}

const mapDispatchToProps = dispatch => {
  return {
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductRequests);



// WEBPACK FOOTER //
// ./src/components/Admin/CaseBody/SubComp/ProductRequests.js